import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken, EmulatedProductData } from '../../GlobalStateContainer/actions'


const EMULATION_MODE_SCOPES = false


/*
 * Scope of Work Actions
 * 
 */

export function fetchScopesList(dispatch) {
    let cmd = 'FETCH_SCOPE_LIST'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)
        //TODO - needs to be fixed
        dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: EmulatedProductData
                }
            }
        )

    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('SOWprojecttypes'), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchScopeError(dispatch) {
    dispatch(
        {
            type: 'FETCH_SCOPE_ERROR',
        }
    )
}

export function createScope(scope) {
    let cmd = 'CREATE_SCOPE'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: scope
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('SOWprojecttypes'), JSON.stringify(scope), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function deleteScope(id) {
    let cmd = 'DELETE_SCOPE'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productBrickId: id,
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('DeleteSOWprojecttype/') + id, "", { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchScope(id) {
    let cmd = 'FETCH_SCOPE'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productBrickId: id,
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('SOWprojecttypes/') + id, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function updateScope(id, scope) {
    let cmd = 'UPDATE_SCOPE'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: scope
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('SOWprojecttypes/') + id, JSON.stringify(scope), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorScope(dispatch) {

    dispatch(
        {
            type: 'SCOPE_ERROR',
        }
    )
}

// tabs
export function fetchScopeTabsList(id) {
    let cmd = 'FETCH_SCOPE_TABS_LIST'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)
        //TODO - needs to be fixed
        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: EmulatedProductData
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('SOWprojecttabs/') + id, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchScopeTabsError(dispatch) {
    dispatch(
        {
            type: 'FETCH_SCOPE_TABS_ERROR',
        }
    )
}

export function deleteTab(id) {
    let cmd = 'DELETE_SCOPE_TAB'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productBrickId: id,
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('DeleteSOWprojecttab/') + id, "", { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchScopeTabs(id) {
    let cmd = 'FETCH_SCOPE_TABS'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productBrickId: id,
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('SOWprojecttypes/') + id, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function updateScopeTabs(id, tab) {
    let cmd = 'UPDATE_SCOPE_TABS'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: tab
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('SOWprojecttabs/') + id, JSON.stringify(tab), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function updateScopeTab(scopeid, tabid, tab) {
    let cmd = 'UPDATE_SCOPE_TAB'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: tab
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('SOWprojecttabs/') + scopeid + '/' + tabid, JSON.stringify(tab), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorScopeTabs(dispatch) {

    dispatch(
        {
            type: 'SCOPE_TABS_ERROR',
        }
    )
}

// questions
export function fetchScopeQuestionsList(quest) {
    let cmd = 'FETCH_SCOPE_TAB_QUESTIONS_LIST'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)
        //TODO - needs to be fixed
        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: EmulatedProductData
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd,
                    payload: {
                        data: quest
                    }
                }
            )

            axios.get(buildRequestUrl('SOWprojecttabquestions/') + quest.id, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    var numQuestionsWithOptions = resp.data.filter((question) => {
                        return question.questionType == "HCB" || question.questionType == "VCB" || question.questionType == "DD" || question.questionType == "RB"
                    }).length

                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: {
                                data: resp.data,
                                numOptQuestions: numQuestionsWithOptions
                            }
                        }
                    )

                    resp.data.forEach((question) => {
                        if (question.questionType == "HCB" ||
                            question.questionType == "VCB" ||
                            question.questionType == "DD" ||
                            question.questionType == "RB") {

                            axios.get(buildRequestUrl('SOWtabquestionoptions/') + question.questionID, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                                .then((resp) => {
                                    dispatch(
                                        {
                                            type: 'FETCH_SCOPE_TAB_QUESTION_OPTIONS_FULFILLED',
                                            payload: {
                                                data: resp
                                            }
                                        }
                                    )
                                })
                                .catch((err) => {
                                    dispatch(
                                        {
                                            type: 'FETCH_SCOPE_TAB_QUESTION_OPTIONS_REJECTED',
                                            payload: err
                                        }
                                    )
                                })
                        }
                    })
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchScopeQuestionsError(dispatch) {
    dispatch(
        {
            type: 'FETCH_SCOPE_TAB_QUESTIONS_ERROR',
        }
    )
}

export function deleteQuestion(id) {
    let cmd = 'DELETE_SCOPE_TAB_QUESTION'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productBrickId: id,
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('DeleteSOWTabQuestions/') + id, "", { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function addTabQuestion(tabid, question) {
    let cmd = 'UPDATE_SCOPE_TAB_QUESTION'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: question
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('SOWprojecttabquestions/') + tabid, JSON.stringify(question), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function updateTabQuestionDetail(tabid, questionid, questionndx, question) {
    let cmd = 'UPDATE_SCOPE_TAB_QUESTION_DETAIL'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: question
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd,
                    payload: {
                        data: questionndx
                    }
                }
            )

            axios.put(buildRequestUrl('SOWprojecttabquestions/') + tabid +'/' + questionid, JSON.stringify(question), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

// options
export function addTabQuestionOption(questionid, option) {
    let cmd = 'UPDATE_SCOPE_TAB_QUESTION_OPTION'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: option
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('SOWtabquestionoptions/') + questionid, JSON.stringify(option), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function updateTabQuestionDetailOption(questionid, optionid, optionndx, option) {
    let cmd = 'UPDATE_SCOPE_TAB_QUESTION_DETAIL_OPTION'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: option
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd,
                    payload: {
                        data: optionndx
                    }
                }
            )

            axios.put(buildRequestUrl('SOWtabquestionoptions/') + questionid + '/' + optionid, JSON.stringify(option), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function deleteOption(id) {
    let cmd = 'DELETE_SCOPE_TAB_QUESTION_OPTION'

    if (EMULATION_ALL || EMULATION_MODE_SCOPES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productBrickId: id,
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('DeleteSOWQuestionOptions/') + id, "", { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}





